document.addEventListener("DOMContentLoaded", () => {
    const floatingNav = document.getElementById("floating-nav");
    const gallery = document.getElementById("gallery");
    const hero = document.querySelector(".inspirations-hero");
    const footer = document.querySelector("footer");

    if (!floatingNav || !gallery || !hero || !footer) return;

    function elementIsIntersecting(el) {
        const rect = el.getBoundingClientRect();
        const vh = window.innerHeight;
        return rect.top < vh && rect.bottom > 0;
    }

    function handleScroll() {
        const heroRect = hero.getBoundingClientRect();
        const galleryRect = gallery.getBoundingClientRect();
        const footerRect = footer.getBoundingClientRect();

        const inHero = heroRect.bottom > 100;
        const inGallery = galleryRect.top < window.innerHeight * 0.5 && galleryRect.bottom > 100;

        // 🔥 footer touche le viewport → on cache
        const footerVisible = elementIsIntersecting(footer);

        const shouldShow = inGallery && !inHero && !footerVisible;

        if (shouldShow) {
            floatingNav.classList.remove("opacity-0", "pointer-events-none");
            floatingNav.classList.add("opacity-100", "pointer-events-auto");
        } else {
            floatingNav.classList.add("opacity-0", "pointer-events-none");
            floatingNav.classList.remove("opacity-100", "pointer-events-auto");
        }
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);

    handleScroll();
});
